// Query removal cannot cancel mutation callbacks or Undo actions that already
// captured private data. Give those callbacks a cheap session-lifetime guard.
let generation = 0;

export function advancePersonalCacheBoundary() {
  generation += 1;
}

export function capturePersonalCacheBoundary(): () => boolean {
  const capturedGeneration = generation;
  return () => capturedGeneration === generation;
}
